var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.statusSpecificConfig.class},[_c('i',{class:_vm.statusSpecificConfig.icon}),_vm._v(" "+_vm._s(_vm.statusSpecificConfig.text)+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254e93a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Teams/Utilities/Lables/TeamStatusLabel.vue
// module id = 838
// module chunks = 0 1